let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("iHSHl")).then(() => parcelRequire('j1uFI'));